/* Scroll-reveal - replaces the React <ScrollReveal>.
 * Any [data-reveal] element animates in once when it enters the viewport
 * (CSS handles the motion; this just flips [data-shown]).
 * [data-reveal="mask"] = clip-path wipe. [data-reveal-delay="120"] staggers. */
(function () {
  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  els.forEach(function (el) {
    var delay = el.getAttribute('data-reveal-delay');
    if (delay) el.style.transitionDelay = delay + 'ms';
  });

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.setAttribute('data-shown', ''); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-shown', '');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0, rootMargin: '0px 0px -20% 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
})();
